import { createSlice } from "@reduxjs/toolkit";
import {
  getBlob,
  createBlob
} from './actions';

export const initialState = {
  blob: { 
    id: '', 
    representations: [] 
  },
  loading: false
};

const slice = createSlice({
  name: 'blobs',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBlob.fulfilled, (state, action) => {
        const { blob } = action.payload;
        
        state.loading = false;
        state.blob = { ...state.blob, ...blob };
      })
      .addCase(getBlob.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBlob.fulfilled, (state, action) => {
        const { blob } = action.payload;
        
        state.loading = false;
        state.blob = { ...state.blob, ...blob };      
      })
      .addCase(createBlob.rejected, (state) => {
        state.loading = false;
      })
  }
})

export default slice.reducer;